import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { IPriceList } from '~/utils/interface/estimate';
import { SortField } from '~/utils/types/common';
import { DEFAULT_PAGE, ROWS_PER_PAGE } from '~/utils/constants/common';
import { handleGetPrices } from './pricesThunk';

export interface PriceState {
  selectPrices: Array<IPriceList>;
  filter: IPriceFilter;
  currentPage: number;
  totalPages: number;
  needRefreshData: boolean;
  prices: Array<IPriceList>;
  selectedPrices: Array<IPriceList>;
  selectedIds: Array<string>;
  priceId: string;
  openAlertDelete: boolean;
  menuSelectedId: string | undefined;
}

interface IPriceFilter {
  page?: number;
  limit?: number;
  search?: string;
  searchFields?: Array<string>;
  sort?: Array<SortField>;
}

const initialState: PriceState = {
  selectPrices: [],
  selectedPrices: [],
  currentPage: DEFAULT_PAGE,
  totalPages: 0,
  needRefreshData: false,
  filter: {
    page: 1,
    limit: ROWS_PER_PAGE,
    search: '',
    searchFields: [],
    sort: [],
  },
  selectedIds: [],
  prices: [],
  priceId: '',
  openAlertDelete: false,
  menuSelectedId: undefined,
};

const priceSlice = createSlice({
  name: 'price',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    setFilter(state, action: PayloadAction<IPriceFilter>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    changeSelectedIds(state, action: PayloadAction<Array<string>>) {
      state.selectedIds = [...action.payload];
    },
    changePriceId(state, action: PayloadAction<string>) {
      state.priceId = action.payload;
    },
    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDelete = action.payload;
    },
    changeMenuSelectId(state, action: PayloadAction<string | undefined>) {
      state.menuSelectedId = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetPrices.pending, (_state, _action) => {})

      .addCase(handleGetPrices.fulfilled, (state, action) => {
        state.prices = [...action.payload.responses];
        state.currentPage = action.payload.pagination.page;
        state.selectedPrices = [...action.payload.responses];
        state.totalPages = action.payload.pagination.totalPages;
        state.needRefreshData = false;
      })

      .addCase(handleGetPrices.rejected, (_state, _action) => {});
  },
});

export const priceActions = priceSlice.actions;

const priceReducer = priceSlice.reducer;
export default priceReducer;
